import Immutable from 'immutable';
import { isEqual } from 'lodash';
import * as Models from 'models';
import { isImmutable } from 'utils/immutable';

export function updateReferenceCitationsIds<T extends Models.TextComponentMap | Models.TextComponent>(
  component: T,
  referencesIds: string[],
): T;
export function updateReferenceCitationsIds(
  component: Models.TextComponentMap | Models.TextComponent,
  referencesIds: string[],
): Models.TextComponentMap | Models.TextComponent {
  const isImmutableMap = isImmutable(component);
  const currentReferences = isImmutableMap
    ? component.get('referenceCitations')?.toJS()
    : component.referenceCitations;

  if (isEqual(referencesIds, currentReferences)) {
    return component;
  }

  if (isImmutableMap) {
    return component.set('referenceCitations', Immutable.List<string>(referencesIds));
  }

  return { ...component, referenceCitations: referencesIds };
}
